
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kosLT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b2df2daac61f0d97$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $b2df2daac61f0d97$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': 'Todos los sitios',
    'navigation.global-shortcuts.apps.analytics': "An\xe1lisis",
    'navigation.global-shortcuts.apps.assets': 'Activos',
    'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
    'navigation.global-shortcuts.apps.company-hub': 'Centro empresarial',
    'navigation.global-shortcuts.apps.compass': 'Compass',
    'navigation.global-shortcuts.apps.confluence': 'Confluence',
    'navigation.global-shortcuts.apps.focus': 'Focus',
    'navigation.global-shortcuts.apps.goals': 'Metas',
    'navigation.global-shortcuts.apps.home': 'Inicio',
    'navigation.global-shortcuts.apps.jira': 'Jira',
    'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
    'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
    'navigation.global-shortcuts.apps.loom': 'Loom',
    'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
    'navigation.global-shortcuts.apps.projects': 'Proyectos',
    'navigation.global-shortcuts.apps.talent': 'Talent',
    'navigation.global-shortcuts.apps.teams': 'Equipos',
    'navigation.global-shortcuts.apps.trello': 'Trello',
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Cerrar',
    'navigation.global-shortcuts.menu-expand-item.site-aria-label': 'Sitio {name}',
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(no disponible en estos momentos)',
    'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Abrir icono de enlace externo',
    'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(cargando)',
    'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(cargando)',
    'navigation.global-shortcuts.sites': 'Sitios de {productName}'
};

});


//# sourceMappingURL=es.ca8079a8.js.map
